import React, {useState, useEffect, useLayoutEffect} from 'react';
import {motion} from 'framer-motion';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import FAQHeroBit from '../components/faq/FAQHeroBit';
import FAQCategoryTabs from '../components/faq/FAQCategoryTabs';
import FAQAccordionBit from '../components/faq/FAQAccordionBit';
import StillNeedHelpBit from '../components/faq/StillNeedHelpBit';

// import '../styles/globals.css';
// import '../styles/contact.css';
import {pageTransition} from "../components/animations/animations";

const FAQPage = () => {
    const [activeCategory, setActiveCategory] = useState('all');
    const [isMobile, setIsMobile] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <motion.div
            variants={pageTransition}
            initial="initial"
            animate="animate"
            exit="exit"
            className="min-h-screen bg-gradient-to-b from-pearl via-pearl to-nude/10"
        >
            <Navbar/>

            <main className="relative min-h-screen lg:min-h-[90vh] overflow-hidden pt-20">
                <div className="container-luxury">
                    {/* Header */}
                    <div className="mb-8 md:mb-12">
                        <FAQHeroBit isMobile={isMobile}/>
                    </div>

                    {/* Search Bar */}
                    <motion.div
                        initial={{opacity: 0, y: 20}}
                        animate={{opacity: 1, y: 0}}
                        transition={{delay: 0.2}}
                        className="mb-8"
                    >
                        <div className="relative">
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                placeholder="Search for answers..."
                                className="w-full px-6 py-4 bg-white border border-nude rounded-2xl text-charcoal placeholder:text-charcoal/30 focus:outline-none focus:border-champagne focus:ring-1 focus:ring-champagne/30"
                            />
                            <svg
                                className="absolute right-6 top-1/2 transform -translate-y-1/2 w-5 h-5 text-charcoal/40"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                            </svg>
                        </div>
                    </motion.div>

                    {/* Category Tabs */}
                    <motion.div
                        initial={{opacity: 0, y: 20}}
                        animate={{opacity: 1, y: 0}}
                        transition={{delay: 0.3}}
                        className="mb-8"
                    >
                        <FAQCategoryTabs
                            activeCategory={activeCategory}
                            onCategoryChange={setActiveCategory}
                            isMobile={isMobile}
                        />
                    </motion.div>

                    {/* FAQ Accordions */}
                    <motion.div
                        initial={{opacity: 0, y: 20}}
                        animate={{opacity: 1, y: 0}}
                        transition={{delay: 0.4}}
                        className="mb-12 md:mb-16"
                    >
                        <FAQAccordionBit
                            activeCategory={activeCategory}
                            searchQuery={searchQuery}
                            isMobile={isMobile}
                        />
                    </motion.div>

                    {/* Still Need Help */}
                    <motion.div
                        initial={{opacity: 0, y: 20}}
                        animate={{opacity: 1, y: 0}}
                        transition={{delay: 0.5}}
                    >
                        <StillNeedHelpBit isMobile={isMobile}/>
                    </motion.div>
                </div>

            </main>

            <Footer/>
        </motion.div>
    );
};

export default FAQPage;